module.exports = __webpack_public_path__ + "static/img/1010_small.b916881.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1010_small.png
// module id = wzvv
// module chunks = 1